/**
 * @generated SignedSource<<f4c75ef562a2c015c32b9222b623a7f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type emailTemplateEdit_EmailTemplateFragment$data = {
  readonly id: string;
  readonly template: {
    readonly body: string;
    readonly key: string;
    readonly previewText: string;
    readonly subject: string;
    readonly variables: ReadonlyArray<string>;
  };
  readonly " $fragmentType": "emailTemplateEdit_EmailTemplateFragment";
};
export type emailTemplateEdit_EmailTemplateFragment$key = {
  readonly " $data"?: emailTemplateEdit_EmailTemplateFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"emailTemplateEdit_EmailTemplateFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "emailTemplateEdit_EmailTemplateFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailTemplate",
      "kind": "LinkedField",
      "name": "template",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subject",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "previewText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "body",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "variables",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PersonalizedEmailTemplate",
  "abstractKey": null
};

(node as any).hash = "a2013f275fa5c3df53ef1f9771703fa6";

export default node;
